export type NuxtHook = any;

export const HOOK_SIDEBAR_OPEN_HISTORY: NuxtHook = "app:sidebar:open:history"
export const HOOK_SIDEBAR_OPEN_COLLECTIONS: NuxtHook = "app:sidebar:open:collections"

export const HOOK_PLAYER_SEEK_TO: NuxtHook = "app:player:seek:to"

export const HOOK_EDITOR_SYNTHESIZE: NuxtHook = "app:editor:synthesize"

export const HOOK_HIGHLIGHT_SPEAKER_SELECTOR: NuxtHook = "app:highlight:speaker:selector"